module.exports = __webpack_public_path__ + "media/packs/images/marker-43801391cfe39b5b28774b88e9766af0.svg";